import { useEffect, useState } from 'react';
import {
  StripeOperationType,
  StripeOperationEvent,
  ProcessableStatus
} from 'lib/types/events';
import { ENotice, ESnapshotExists } from 'lib/types';
import { getFirebaseContext } from 'utils/firebase';

export const useCheckInvoiceCreationStatus = (
  notice: ESnapshotExists<ENotice>
) => {
  const [invoiceCreationInProgress, setInvoiceCreationInProgress] =
    useState(true);
  const [invoiceCreationFailed, setInvoiceCreationFailed] = useState(false);

  useEffect(() => {
    const unsubscribe = getFirebaseContext()
      .eventsRef<StripeOperationEvent>()
      .where(
        'data.operationType',
        '==',
        StripeOperationType.NOTICE_INVOICE_CREATION
      )
      .where('data.userNoticeId', '==', notice.id)
      .orderBy('createdAt', 'desc')
      .limit(1)
      .onSnapshot(eventsSnap => {
        if (!eventsSnap.docs.length) {
          setInvoiceCreationInProgress(false);
          setInvoiceCreationFailed(false);
          return;
        }
        const latestEvent = eventsSnap.docs[0].data();
        if (latestEvent.status === ProcessableStatus.SUCCESS) {
          setInvoiceCreationInProgress(false);
          setInvoiceCreationFailed(false);
          return;
        }
        if (latestEvent.status === ProcessableStatus.PERMANENT_FAILURE) {
          setInvoiceCreationInProgress(false);
          setInvoiceCreationFailed(true);
          return;
        }
        // IN_PROGRESS or no status yet (freshly created)
        setInvoiceCreationInProgress(true);
        setInvoiceCreationFailed(false);
      });
    return () => {
      unsubscribe();
    };
  }, [notice.id]);

  return { invoiceCreationInProgress, invoiceCreationFailed };
};

/**
 * @deprecated Use `useCheckInvoiceCreationStatus` instead.
 * Kept for backward compatibility during migration.
 */
export const useCheckInvoiceCreationInitiated = (
  notice: ESnapshotExists<ENotice>
) => {
  const { invoiceCreationInProgress } = useCheckInvoiceCreationStatus(notice);
  return invoiceCreationInProgress;
};
